<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.TRADE_NAME + ' - ' + r.INVOICE_NUMBER" [term]="t"></ngb-highlight>
</ng-template>
<app-page-header [heading]="'New Credit Note'" [icon]="'fa-plus'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
    <div class="row">

        <div class="form-group col-lg-3">
            <label>Credit Note No</label><span class="text-danger">&nbsp;*</span>
            <input [ngModel]="add_crd_note.credit_note_no" class="form-control" id="credit_note_no" name="credit_note_no" readonly>
        </div>

        <div class="form-group col-lg-3">
            <label>Date</label><span class="text-danger">&nbsp;*</span>
            <input (ngModelChange)="add_crd_note.cnt_date = $event" [max]="getToday()" [ngModel]="add_crd_note.cnt_date | date:'yyyy-MM-dd'"
                class="form-control" id="add_crd_note" name="add_crd_note" type="date">
        </div>


        <div class="form-group col-lg-3">
            <label>Customer Name</label><span class="text-danger">&nbsp;*</span>
            <ngx-select-dropdown (change)="onCustomerChange($event)" [(ngModel)]="add_crd_note.customer_name" [config]="utils.dropConfig({displayKey: 'CUSTOMER_NAME',placeholder: 'Select Customer',searchOnKey: 'CUSTOMER_NAME'})" [multiple]="false" [options]="customer_options" class="form-control size" name="customer" [disabled]="isEdit"></ngx-select-dropdown>
        </div>

    </div>
    <div class="crdt_table">
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <h5 class="list-header">Particulars List</h5>
        <div class="form-group">
            <table class="table tbl table-bordered">
            <thead>
                <tr>
                    <th>#</th>
                    <th class="text-left" style="width:25%">Item&nbsp;<span class="text-danger">*</span></th>
                    <th class="text-left">Rate</th>
                    <th class="text-left">Quantity</th>
                    <th class="text-left">Total</th>
                    <th class="text-left">Return Rate&nbsp;<span class="text-danger">*</span></th>
                    <th class="text-left">Return Quantity&nbsp;<span class="text-danger">*</span></th>
                    <th class="text-left">Return Total</th>
                    <th class="text-left" style="width:20%">Reason&nbsp;<span class="text-danger">*</span></th>
                    <th style="width:9%">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of crd_note_dtls.items; let i = index">
                    <td class="text-center">{{ i + 1 }}</td>
                    <td>
                        <input (selectItem)="set_item($event,i)" [(ngModel)]="row.item"
                            [class.is-invalid]="searchFailed"
                            [inputFormatter]="formatter"
                            [ngModelOptions]="{standalone: true}" [ngbTypeahead]="item_search"
                            [resultTemplate]="rt" class="form-control" id="typeahead-http{{i}}"
                            placeholder="Search Invoice/Medicine...." style="height: 29px;margin-bottom: 2px"
                            type="text"/>
                    </td>
                    <td class="text-right">
                        <input type="text" class="form-control" [(ngModel)]="row.rate" [readOnly]="true">
                    </td>
                    <td class="text-right">
                        <input type="text" class="form-control" [(ngModel)]="row.qty" [readOnly]="true">
                    </td>
                    <td class="text-right">
                        <input type="text" class="form-control" [(ngModel)]="row.total" [readOnly]="true">
                    </td>
                    <td class="text-right">
                        <input type="text" class="form-control" [(ngModel)]="row.return_rate" (ngModelChange)="calculateRowTotal(row)" (keypress)="allowFloatNumbers($event)" maxlength="8">
                    </td>
                    <td class="text-right">
                        <input type="text" class="form-control" [(ngModel)]="row.return_qty" (ngModelChange)="calculateRowTotal(row)" (keypress)="allowFloatNumbers($event)" maxlength="4">
                    </td>
                    <td class="text-right">
                        <input type="text" class="form-control" [(ngModel)]="row.return_total" maxlength="8" [readOnly]="true">
                    </td>
                    <td>
                        <textarea [(ngModel)]="row.reason" class="form-control" type="text" maxlength="250"></textarea>
                    </td>
                    <td>
                        <button (click)="addRow()" class="btn btn-success btn-sm" title="Add new row">
                            <i class="fa fa-plus" style="color: white;"></i>
                        </button>&nbsp;&nbsp;
                        <button *ngIf="i > 0" (click)="removeRow(i)" class="btn btn-danger btn-sm" title="Remove row">
                            <i class="fa fa-minus" style="color: white;"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            </table>

            <div class="row">
                <div class="pull-right">
                <button (click)="saveCreditNote()" *ngIf="user_rights.ADD == '1'"
                        class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Save&nbsp;
                </button>&nbsp;&nbsp;
                <!-- <button (click)="Updatesale()" *ngIf="user_rights.EDIT == '1'"
                        class="btn  btn-info btn-sm ng-star-inserted" type="button">&nbsp;Update&nbsp;
                </button>&nbsp;&nbsp; -->
                </div>
            </div>
        </div>
    </div>


</div>